import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span className="font-heading font-black text-[8rem] md:text-[12rem] leading-none text-background-200 select-none pointer-events-none">
        404
      </span>
      <h1 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mt-2 mb-3">
        这一页暂时没有内容
      </h1>
      <p className="font-label text-sm text-foreground-500 mb-1">
        你访问的地址可能已经更新或不存在
      </p>
      <p className="font-label text-xs text-foreground-400 mb-7">{location.pathname}</p>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-label text-sm font-medium transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line leading-none"></i>
          回到首页
        </Link>
        <Link
          to="/kuaibao"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 font-label text-sm transition-colors whitespace-nowrap"
        >
          <i className="ri-list-check-2 leading-none"></i>
          浏览今日快报
        </Link>
      </div>
    </div>
  );
}